"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var __1 = require("../../");
var context_1 = require("../../../context");
var Grid_1 = require("../../Grid");
var SectionHeading_1 = __importDefault(require("../../SectionHeading"));
var DisabilitiesDetailsProfile = function (_a) {
    var client = _a.client;
    var trans = context_1.useSemantics().trans;
    var disabilities = client.disabilities;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SectionHeading_1.default, { className: "pb-8", heading: trans('optiiva::headings.disabilities') }),
        disabilities &&
            disabilities.length > 0 &&
            disabilities.map(function (disability, index) { return (react_1.default.createElement(react_1.default.Fragment, { key: "disability-" + disability.id },
                react_1.default.createElement(Grid_1.Grid, null,
                    react_1.default.createElement(Grid_1.GridColumn, { width: "w-1/2" },
                        react_1.default.createElement(__1.DataRow, { dropBorder: true, flush: true, label: trans('optiiva::labels.category'), value: disability.category_readable })),
                    react_1.default.createElement(Grid_1.GridColumn, { width: "w-1/2" },
                        react_1.default.createElement(__1.DataRow, { dropBorder: true, flush: true, label: trans('optiiva::labels.type'), value: disability.type }))),
                react_1.default.createElement(__1.DataRow, { dropBorder: index + 1 === disabilities.length, label: trans('optiiva::labels.additional-info'), value: disability.info }))); })));
};
exports.default = DisabilitiesDetailsProfile;
//# sourceMappingURL=DisabilitiesDetailsProfile.js.map